<template>
  <div class="shipments-filters">
    <AlgoliaSelectedFiltersWatcher />

    <AlgoliaDateFilter
      v-for="(dateFilter, index) in dateFilters"
      :key="index"
      :index="index"
      :dateFilter="dateFilter"
    />
    <AlgoliaSelectableFilters :arrFilters="arrFilters" />
    <AlgoliaNumericFilters :numFilters="numericFilters" />
  </div>
</template>

<script>
import AlgoliaSelectableFilters from '@/components/general/AlgoliaSelectableFilters'
import AlgoliaDateFilter from '@/components/general/AlgoliaDateFilter2'
import AlgoliaSelectedFiltersWatcher from '@/components/general/AlgoliaSelectedFiltersWatcher'
import AlgoliaNumericFilters from '@/components/general/AlgoliaNumericFilters'

export default {
  name: 'ReportShipmentsFilters',
  components: {
    AlgoliaSelectableFilters,
    AlgoliaDateFilter,
    AlgoliaSelectedFiltersWatcher,
    AlgoliaNumericFilters
  },
  props: {},
  data () {
    return {
      typeColorMap: {
        '1PL': '#4CAF50',
        '2PL': '#2196F3',
        '3PL': '#9C27B0',
        'Express': '#FF9800'
      },
      dateFilters: [
        // { title: this.$i18n.t('shipments.departure'), attribute: 'origin.departure', primary: true, default: { lengthInMonths: 4, futureInWeeks: 3 } },
        // { title: this.$i18n.t('shipments.arrival'), attribute: 'destination.arrival' }
        { title: this.$i18n.t('shipments.departure'), attribute: 'pickupLocal.from', primary: true, default: { lengthInMonths: 3, futureInWeeks: 2 } },
        { title: this.$i18n.t('shipments.arrival'), attribute: 'deliveryLocal.from' }
      ]
    }
  },
  computed: {
    arrFilters () {
      return [
        { title: this.$i18n.t('shipments.labels'), attribute: 'labels' },
        { title: this.$i18n.t('shipments.status'), attribute: 'status', i18nPreffix: 'shipments.' }
      ]
    },
    numericFilters () {
      return [
        { title: this.$i18n.t('shipments.volume'), attribute: 'volume'},
        { title: this.$i18n.t('shipments.weight'), attribute: 'weight'}
      ]
    },
  }
}
</script>
